import {
  validateBattlecardStructureIntra,
  validateBattlecardStructureSchema,
} from "./Validation/ValidateScripts/1a_BattlecardStructureCTS";
import {
  validateBattlecardTerritoryGroupTypesSchema,
  validateBattlecardTerritoryGroupTypesIntra,
} from "./Validation/ValidateScripts/1b_BattlecardTerritoryGroupTypesCTS";

import {
  validateQuotaComponentsSchema,
  validateQuotaComponentsIntra,
} from "./Validation/ValidateScripts/2a_QuotaComponentsCTS";

import {
  validateQCAssignmentSchema,
  //validateQCAssignmentIntra,
} from "./Validation/ValidateScripts/2b_QCAssignmentsCTS";

import {
  validateTGSchema,
  validateTGIntra,
} from "./Validation/ValidateScripts/3_TerritoryGroupsCTS";
import {
  battlecardBuilderSchema,
  battlecardTerritoryGroupTypesSchema,
  quotaComponentsSchema,
  qcAssignmentSchema,
  tgSchema,
} from "./schemas";

import { isDevModeDefaultUser } from "./config";

import devFlag from "./assets/devFlag.png";
import qrFlag from "./assets/qrFlag.png";
import stgFlag from "./assets/stgFlag.png";
import euFlag from "./assets/european-union.png";
import usFlag from "./assets/us-flag.png";

export const CHUNK_SIZE = 5 * 1024 * 1024; // 1MB, adjust as needed

export const ACCORDIONIDS_TO_VALIDATION_FUNCTION_MAPPING = {
  1: {
    scripts: {
      intraValidationTestSuite: validateBattlecardStructureIntra,
      schemaValidationTestSuite: validateBattlecardStructureSchema,
      interValidationSuite: null,
    },
  },
  2: {
    scripts: {
      schemaValidationTestSuite: validateBattlecardTerritoryGroupTypesSchema,
      intraValidationTestSuite: validateBattlecardTerritoryGroupTypesIntra,
      interValidationSuite: null,
    },
  },
  3: {
    scripts: {
      schemaValidationTestSuite: validateQuotaComponentsSchema,
      intraValidationTestSuite: validateQuotaComponentsIntra,
      interValidationSuite: null,
    },
  },
  4: {
    scripts: {
      schemaValidationTestSuite: validateQCAssignmentSchema,
      intraValidationTestSuite: null,
      interValidationSuite: null,
    },
  },
  5: {
    scripts: {
      schemaValidationTestSuite: validateTGSchema,
      intraValidationTestSuite: validateTGIntra,
      interValidationSuite: null,
    },
  },
  6: {
    scripts: {
      schemaValidationTestSuite: null,
      intraValidationTestSuite: null,
      interValidationSuite: null,
    },
  },
  7: {
    scripts: {
      schemaValidationTestSuite: null,
      intraValidationTestSuite: null,
      interValidationSuite: null,
    },
  },
  8: {
    scripts: {
      schemaValidationTestSuite: null,
      intraValidationTestSuite: null,
      interValidationSuite: null,
    },
  },
  9: {
    scripts: {
      schemaValidationTestSuite: null,
      intraValidationTestSuite: null,
      interValidationSuite: null,
    },
  },
  10: {
    scripts: {
      schemaValidationTestSuite: null,
      intraValidationTestSuite: null,
      interValidationSuite: null,
    },
  },
  11: {
    scripts: {
      schemaValidationTestSuite: null,
      intraValidationTestSuite: null,
      interValidationSuite: null,
    },
  },
  12: {
    scripts: {
      schemaValidationTestSuite: null,
      intraValidationTestSuite: null,
      interValidationSuite: null,
    },
  },
  13: {
    scripts: {
      schemaValidationTestSuite: null,
      intraValidationTestSuite: null,
      interValidationSuite: null,
    },
  },
  14: {
    scripts: {
      schemaValidationTestSuite: null,
      intraValidationTestSuite: null,
      interValidationSuite: null,
    },
  },
  15: {
    scripts: {
      schemaValidationTestSuite: null,
      intraValidationTestSuite: null,
      interValidationSuite: null,
    },
  },
  16: {
    scripts: {
      schemaValidationTestSuite: null,
      intraValidationTestSuite: null,
      interValidationSuite: null,
    },
  },
  17: {
    scripts: {
      schemaValidationTestSuite: null,
      intraValidationTestSuite: null,
      interValidationSuite: null,
    },
  },
};

export const TEST_SUITE_TYPES = {
  intraValidation: "Intra-Dataset Validation",
  schema: "Dataset Schema Validation",
  interValidation: "Inter-Dataset Validation",
};

export const TEST_STATUS_TYPES = {
  failed: "failed",
  succeeded: "succeeded",
};

export const SCHEMAS = {
  battlecardBuilderSchema: battlecardBuilderSchema,
  battlecardTerritoryGroupTypesSchema: battlecardTerritoryGroupTypesSchema,
  quotaComponentsSchema: quotaComponentsSchema,
  qcAssignmentSchema: qcAssignmentSchema,
  tgSchema: tgSchema,
};

export const SCHEMA_ERROR_TYPE_PARAMS_KEY = {
  required: {
    key: "missingProperty",
    propertyisAccesssedThroughInstancePath: false,
    isPropertyFailedItem: true,
  },
  additionalProperties: {
    key: "additionalProperty",
    propertyisAccesssedThroughInstancePath: false,
    isPropertyFailedItem: true,
  },
  type: {
    key: "type",
    propertyisAccesssedThroughInstancePath: true,
    isPropertyFailedItem: false,
  },
};

export const customerAccountsInfo =
  "Some new columns have been added for this step such as Effectivedate. You can skip this step within Autopilot and upload the file directly through the application.";

export const geoHierarchyInfo =
  "Please reference the documentation guide to understand how to create this file or you can skip this step within Autopilot and upload the file directly through the application.";

export const SCRIPTS_LAUNCH_CONFIG = {
  Battlecards: {
    name: "Battlecards",
    title: "Build Battlecards",
    currentStepIdRequiredToLaunch: 3,
    stepSucceededIdRequiredToLaunch: 2,
    isLaunchable: false,
    endpoint: "/BuildBattlecards",
    requiredQueryParams: [
      "url",
      "token",
      "tenantId",
      "planningCycleId",
      "deploymentModelId",
      "tenantGlobalId",
      "dataModelId",
    ],
  },
  QuotaComponents: {
    name: "QuotaComponents",
    title: "Build QuotaComponents",
    currentStepIdRequiredToLaunch: 5,
    stepSucceededIdRequiredToLaunch: 4,
    isLaunchable: false,
    endpoint: "/BuildQuotaComponents",
    requiredQueryParams: [
      "url",
      "token",
      "deploymentModelId",
      "tenantGlobalId",
      "dataModelId",
    ],
  },
  TerritoryGroups: {
    name: "TerritoryGroups",
    title: "Build TerritoryGroups",
    currentStepIdRequiredToLaunch: 6,
    stepSucceededIdRequiredToLaunch: 5,
    isLaunchable: false,
    endpoint: "/BuildTerritoryGroups",
    requiredQueryParams: [
      "url",
      "token",
      "tenantId",
      "deploymentModelId",
      "tenantGlobalId",
      "dataModelId",
    ],
  },
  CustomerAccountHierarchy: {
    name: "CustomerAccountHierarchy",
    title: "Build CustomerAccountHierarchy",
    skipped: false,
    currentStepIdRequiredToLaunch: 7,
    stepSucceededIdRequiredToLaunch: 6,
    isLaunchable: false,
    endpoint: "/BuildCustomerAccountHierarchy",
    requiredQueryParams: [
      "url",
      "token",
      "planningCycleId",
      "tenantGlobalId",
      "dataModelId",
    ],
  },
  GeoHierarchy: {
    name: "GeoHierarchy",
    title: "Build GeoHierarchy",
    skipped: false,
    currentStepIdRequiredToLaunch: 8,
    stepSucceededIdRequiredToLaunch: 7,
    isLaunchable: false,
    endpoint: "/BuildGeoHierarchy",
    requiredQueryParams: [
      "url",
      "token",
      "planningCycleId",
      "tenantGlobalId",
      "dataModelId",
    ],
  },
  CustomHierarchy: {
    name: "CustomHierarchy",
    title: "Build CustomHierarchy",
    skipped: false,
    currentStepIdRequiredToLaunch: 9,
    stepSucceededIdRequiredToLaunch: 8,
    isLaunchable: false,
    endpoint: "/BuildCustomHierarchy",
    requiredQueryParams: [
      "url",
      "token",
      "planningCycleId",
      "tenantGlobalId",
      "dataModelId",
    ],
  },
  TerritoryRules: {
    name: "TerritoryRules",
    title: "Build TerritoryRules",
    currentStepIdRequiredToLaunch: 10,
    stepSucceededIdRequiredToLaunch: 9,
    isLaunchable: false,
    endpoint: "/BuildTerritoryRules",
    requiredQueryParams: [
      "url",
      "token",
      "planningCycleId",
      "deploymentModelId",
      "tenantGlobalId",
      "dataModelId",
    ],
  },
  TerritoryAssignments: {
    name: "TerritoryAssignments",
    title: "Build TerritoryAssignments",
    currentStepIdRequiredToLaunch: 11,
    stepSucceededIdRequiredToLaunch: 10,
    isLaunchable: false,
    endpoint: "/BuildTerritoryAssignments",
    requiredQueryParams: [
      "url",
      "token",
      "planningCycleId",
      "deploymentModelId",
      "tenantGlobalId",
      "dataModelId",
    ],
  },
  QuotaSheets: {
    name: "QuotaSheets",
    title: "Build QuotaSheets",
    skipped: false,
    currentStepIdRequiredToLaunch: 15,
    stepSucceededIdRequiredToLaunch: 14,
    isLaunchable: false,
    endpoint: "/BuildQuotaSheets",
    requiredQueryParams: [
      "url",
      "token",
      "deploymentModelId",
      "tenantGlobalId",
      "dataModelId",
    ],
  },
  ActivityFiles: {
    name: "ActivityFiles",
    title: "Build ActivityFiles",
    skipped: false,
    currentStepIdRequiredToLaunch: 16,
    stepSucceededIdRequiredToLaunch: 15,
    isLaunchable: false,
    endpoint: "/BuildActivityFiles",
    requiredQueryParams: [
      "url",
      "token",
      "planningCycleId",
      "deploymentModelId",
      "tenantGlobalId",
      "dataModelId",
    ],
  },
  Pins: {
    name: "Pins",
    title: "Build Pins",
    currentStepIdRequiredToLaunch: 17,
    stepSucceededIdRequiredToLaunch: 16,
    isLaunchable: false,
    endpoint: "/BuildPins",
    requiredQueryParams: [
      "url",
      "token",
      "planningCycleId",
      "deploymentModelId",
      "prefix",
      "tenantGlobalId",
      "dataModelId",
    ],
  },
  CrossOverAccounts: {
    name: "CrossOverAccounts",
    title: "Build CrossOverAccounts",
    currentStepIdRequiredToLaunch: 18,
    stepSucceededIdRequiredToLaunch: 17,
    isLaunchable: false,
    endpoint: "/BuildCrossOverAccounts",
  },
};

export const defaultScriptsContext = {
  launchedFromAccordionId: null,
  isRunning: false,
  scriptRunningName: null,
  scriptRunningError: false,
  scriptRunningCurrentStep: null,
  scriptRunningProgress: 0,
  status: "not started",
  action: null,
  numberInQueue: 0,
  queueLength: 0,
  exception: "",
  message: "",
};

export const accordionConfigData = [
  {
    id: 1,
    displayId: "1A",
    title: "Battlecard Structure",
    content: "Build Battlecards",
    backEndFileName: "1a.BCStructure.xlsx",
    file: null,
    fileContents: null,
    status: "Pending",
    fileTestResponse: null,
    errorDetails: null,
    isUploadedOnBackend: false,
    isSkippable: false,
    testOnBackEnd: false,
  },
  {
    id: 2,
    displayId: "1B",
    title: "Battlecard Territory Group Types",
    content: "Build Battlecards",
    backEndFileName: "1b.BCTerritoryGroupTypes.xlsx",
    file: null,
    fileContents: null,
    status: "Pending",
    fileTestResponse: null,
    errorDetails: null,
    isUploadedOnBackend: false,
    isSkippable: false,
    testOnBackEnd: false,
  },
  {
    id: 3,
    displayId: "2A",
    title: "Quota Components",
    content: "Build QuotaComponents",
    backEndFileName: "2a.QuotaComponents.xlsx",
    file: null,
    fileContents: null,
    status: "Pending",
    fileTestResponse: null,
    errorDetails: null,
    isUploadedOnBackend: false,
    isSkippable: true,
    testOnBackEnd: false,
  },
  {
    id: 4,
    displayId: "2B",
    title: "QC Assignments",
    content: "Build QuotaComponents",
    backEndFileName: "2b.QCAssignments.xlsx",
    file: null,
    fileContents: null,
    status: "Pending",
    fileTestResponse: null,
    errorDetails: null,
    isUploadedOnBackend: false,
    isSkippable: true,
    testOnBackEnd: false,
  },
  {
    id: 5,
    displayId: "3",
    title: "Territory Groups",
    content: "Build TerritoryGroups",
    backEndFileName: "3.TerritoryGroups.xlsx",
    file: null,
    fileContents: null,
    status: "Pending",
    fileTestResponse: null,
    errorDetails: null,
    isUploadedOnBackend: false,
    isSkippable: false,
    testOnBackEnd: false,
  },
  {
    id: 6,
    displayId: "4A",
    title: "Customer Account Hierarchy",
    content: "Build CustomerAccountHierarchy",
    backEndFileName: "4a.CustomerHierarchy.xlsx",
    file: null,
    fileContents: null,
    status: "Pending",
    fileTestResponse: null,
    errorDetails: null,
    isUploadedOnBackend: false,
    isSkippable: true,
    testOnBackEnd: true,
  },
  {
    id: 7,
    displayId: "4B",
    title: "Geo Hierarchy",
    content: "Build GeoHierarchy",
    backEndFileName: "4b.GeoHierarchy.xlsx",
    file: null,
    fileContents: null,
    status: "Pending",
    fileTestResponse: null,
    errorDetails: null,
    isUploadedOnBackend: false,
    isSkippable: true,
    testOnBackEnd: true,
  },
  {
    id: 8,
    displayId: "4C",
    title: "Custom Hierarchy (e.g. Product)",
    content: "Build CustomHierarchy",
    backEndFileName: "4c.CustomHierarchies.xlsx",
    file: null,
    fileContents: null,
    status: "Pending",
    fileTestResponse: null,
    errorDetails: null,
    isUploadedOnBackend: false,
    isSkippable: true,
    testOnBackEnd: true,
  },
  {
    id: 9,
    displayId: "5",
    title: "Territory Rules",
    content: "Build TerritoryRules",
    backEndFileName: "5.TerritoryRules.xlsx",
    file: null,
    fileContents: null,
    status: "Pending",
    fileTestResponse: null,
    errorDetails: null,
    isUploadedOnBackend: false,
    isSkippable: false,
    testOnBackEnd: true,
  },
  {
    id: 10,
    displayId: "6",
    title: "Seller Assignments",
    content: "Build TerritoryAssignments",
    backEndFileName: "6.TerritoryAssignments.xlsx",
    file: null,
    fileContents: null,
    status: "Pending",
    fileTestResponse: null,
    errorDetails: null,
    isUploadedOnBackend: false,
    isSkippable: true,
    testOnBackEnd: true,
  },
  {
    id: 11,
    displayId: "7A",
    title: "Quota Sheets",
    content: "Build QuotaSheets",
    backEndFileName: "7a.QuotaSheets.xlsx",
    file: null,
    fileContents: null,
    status: "Pending",
    fileTestResponse: null,
    errorDetails: null,
    isUploadedOnBackend: false,
    isSkippable: true,
    testOnBackEnd: true,
  },
  {
    id: 12,
    displayId: "7B",
    title: "QS Columns",
    content: "Build QSColumns",
    backEndFileName: "7b.QSColumns.xlsx",
    file: null,
    fileContents: null,
    status: "Pending",
    fileTestResponse: null,
    errorDetails: null,
    isUploadedOnBackend: false,
    isSkippable: true,
    testOnBackEnd: true,
  },
  {
    id: 13,
    displayId: "7C",
    title: "QS to BC Map",
    content: "Build QSToBCMap",
    backEndFileName: "7c.QSToBCMap.xlsx",
    file: null,
    fileContents: null,
    status: "Pending",
    fileTestResponse: null,
    errorDetails: null,
    isUploadedOnBackend: false,
    isSkippable: true,
    testOnBackEnd: true,
  },
  {
    id: 14,
    displayId: "7D",
    title: "QS to QC Map",
    content: "Build QSToQCMap",
    backEndFileName: "7d.QSToQCMap.xlsx",
    file: null,
    fileContents: null,
    status: "Pending",
    fileTestResponse: null,
    errorDetails: null,
    isUploadedOnBackend: false,
    isSkippable: true,
    testOnBackEnd: true,
  },
  {
    id: 15,
    displayId: "8",
    title: "Activity Files",
    content: "Build ActivityFiles",
    backEndFileName: "8.ActivityFiles.xlsx",
    file: null,
    fileContents: null,
    status: "Pending",
    fileTestResponse: null,
    errorDetails: null,
    isUploadedOnBackend: false,
    isSkippable: false,
    testOnBackEnd: true,
  },
  {
    id: 16,
    displayId: "9",
    title: "Pins",
    content: "Build Pins",
    backEndFileName: "9.Pins.xlsx",
    file: null,
    fileContents: null,
    status: "Pending",
    fileTestResponse: null,
    errorDetails: null,
    isUploadedOnBackend: false,
    isSkippable: true,
    testOnBackEnd: true,
  },
];

export const DEFAULT_APP_STATE = {
  user: isDevModeDefaultUser ? true : false,
  token: "token",
  planningCycle: 123,
  org: "gaspard",
  stateObject: null,
  tenantId: 456,
  tenantGlobalId: "tenantGlobalId",
  planningCycleId: 789,
  deploymentModelId: 1112,
  url: "https://api.us.salesplanning.varicent.com/graphql",
  country: "USA",
  levelName: "Counties",
  prefix: "A",
  dataModelId: "test",
};

export const FLAGS_CONFIG = {
  dev: {
    name: "Development",
    flag: devFlag,
  },
  qr: {
    name: "QR",
    flag: qrFlag,
  },
  stg: {
    name: "Staging",
    flag: stgFlag,
  },
  eu: {
    name: "European Union",
    flag: euFlag,
  },
  us: {
    name: "United States",
    flag: usFlag,
  },
};

export const REQUIRED_HEADERS_CONFIG = [
  {
    id: 1,
    category: "Battlecard Structure",
    columnHeaders: "Name*, ParentName*, Type*, LocalCurrency*, OwnerID",
  },
  {
    id: 2,
    category: "Battlecard Territory Group Types",
    columnHeaders:
      "BattlecardName*, TerritoryGroupType*, Precedence*, Alias, OwnerID",
  },
  {
    id: 3,
    category: "Quota Components",
    columnHeaders: "QuotaComponent*",
  },
  {
    id: 4,
    category: "QC Assignments",
    columnHeaders: "QuotaComponent*, BattlecardName*",
  },
  {
    id: 5,
    category: "Territory Groups",
    columnHeaders: "TerritoryGroupName*, Parent*, BattlecardName*",
  },
  {
    id: 6,
    category: "Customer Account Hierarchy",
    columnHeaders:
      "Name*, Key*, ParentKey*, City, StateProvince, Address1, Address2, County, ZipPostal, Industry",
    info: customerAccountsInfo,
  },
  {
    id: 7,
    category: "Geo Hierarchy",
    columnHeaders: "CountryCode*, Depth*, Type*",
    info: geoHierarchyInfo,
  },
  {
    id: 8,
    category: "Custom Hierarchy",
    columnHeaders: "Name*, Key*, ParentKey*",
  },
  {
    id: 9,
    category: "Territory Rules",
    columnHeaders:
      "BattlecardName*, TerritoryGroupName*, TerritoryID*, TerritoryName*, RuleType*, HierarchyInclusionKey*, HierarchyExclusionKey, Hierarchy*, StartDate, EndDate",
  },
  {
    id: 10,
    category: "Territory Assignments",
    columnHeaders:
      "BattlecardName*, TerritoryID*, EmailAddress*, OwnershipPercentage*",
  },
  {
    id: 11,
    category: "Quota Sheets",
    columnHeaders: "QuotaSheet*",
  },
  {
    id: 12,
    category: "QS Columns",
    columnHeaders:
      "QuotaSheet*, Column*, Exists*, QuotaComponent*, Source*, Format*, BalancingMetric*, StartDate, EndDate",
  },
  {
    id: 13,
    category: "QS to BC Map",
    columnHeaders: "BattlecardName*, QuotaSheet*",
  },
  {
    id: 14,
    category: "QS to QC Map",
    columnHeaders: "QuotaComponent*, QuotaSheet*",
  },
  {
    id: 15,
    category: "Activity Files",
    columnHeaders:
      "BattlecardName*, CustomerAccounts*, Date*, Sales*, QuotaComponent*, Geographies*, CustomColumn1, CustomColumn2",
  },
  {
    id: 16,
    category: "Pins",
    columnHeaders: "Country*, Name*, ZipPostal*, Latitude, Longitude",
  },
  {
    id: 17,
    category: "Crossover Accounts",
    columnHeaders:
      "TerritoryID*, NewTerritoryID*, AccountID*, AccountName*, Optional Columns",
  },
];
